import { Input } from "antd";
import { useIntl } from "react-intl";

import { FeedbackQuestion } from "../candidate-feedback.types";

import styles from "./FeedbackOpenEndedQuestion.module.css";

const { TextArea } = Input;

interface FeedbackOpenEndedQuestionProps {
  question: FeedbackQuestion;
  value?: string;
  onChange: (questionId: number, value: string) => void;
}

export function FeedbackOpenEndedQuestion({ question, value, onChange }: FeedbackOpenEndedQuestionProps) {
  const intl = useIntl();
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(question.questionId, e.target.value);
  };

  const textAreaId = `feedback-question-${question.questionId}`;

  return (
    <div className={styles.questionContainer}>
      <label htmlFor={textAreaId} className={styles.questionText}>
        {question.text.value}
      </label>
      <TextArea
        id={textAreaId}
        value={value}
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: "candidate.feedback.responsePlaceholder",
          defaultMessage: "Enter your response here...",
        })}
        rows={4}
        maxLength={2000}
        showCount={true}
        className={styles.textArea}
      />
    </div>
  );
}
